import { File } from "../types";
import {
  IndustrialProcessType,
  MaterialGradeType,
  PartTypeSchema,
  PartTypeType,
  QuoteRequestLineStatusSchema,
  QuoteRequestLineStatusType,
} from "../types";
import { IndustrialProcess } from "../types/IndustrialProcess";
import { LayoutStatus } from "../types/LayoutStatus";
import { MaterialGrade } from "../types/MaterialGrade";

export const mockQuoteRequestLine: {
  index: number;
  quantity: number;
  materialGrade: MaterialGradeType;
  productLines: {
    id: string;
    quantity: number;
    price: number;
    name: string;
    product: {
      price: number;
      id: string;
      name: string;
      companyId: string;
      supplierId: string;
    };
  }[];
  declineReason: string | null;
  productsMarginRatio: number | null;
  designOfficeHourlyRate: number | null;
  designOfficeTime: number | null;
  designOfficeMarginRatio: number | null;
  id: string;
  quoteRequestId: string;
  comment: string;
  partId: string;
  status: QuoteRequestLineStatusType;
  createdAt: Date;
  part: {
    id: string;
    name: string;
    materialGrade: MaterialGradeType;
    height: number;
    length: number;
    width: number;
    quantityInAssembly: number;
    type: PartTypeType | null;
    files: File[];
  };
  layout: {
    status: LayoutStatus;
    id: string;
    useNesting: boolean | null;
    materialSupplierId: string;
    scrapRatio: number | null;
    hasAutoScrapRatio: boolean;
    scrapMaterialBillingRate: number | null;
    materialsLogisticsCostsRatio: number;
    margin: number;
    materialLayout: {
      price: number;
      quantity: number;
      maxPartsPerLayout: number | null;
      height: number;
      length: number;
      width: number;
      type: PartTypeType;
      materialGrade: MaterialGradeType | null;
    };
    quoteRequestLines: {
      quantity: number;
      part: {
        width: number;
        length: number;
      };
    }[];
  };
  processSteps: {
    id: string;
    industrialProcess: IndustrialProcessType;
    actionsPerPartCount: number;
    contourLengthMm: number | null;
    linearSpeed: number | null;
    materialLoadTimeMinutes: number | null;
    partLoadTimeMinutes: number | null;
    machinePreparationTime: number;
    machineHourlyPrice: number;
    manTime: number | null;
    manHourlyPrice: number;
    fixedCost: number | null;
    isFixedCostPerSeries: boolean;
    fixedCostPerSeries: number | null;
    margin: number | null;
    machineActionsPerMinuteCount: number;
    toolingCost: number;
    partsToPackQuantity: number | null | undefined;
    partsToControlRatio: number | null | undefined;
    companyMachineId: string;
    productsMarginRatio: number | null;
    packingHourlyPrice: number | null | undefined;
    otherMachineTime: number | null | undefined;
    bulkFactor: number | null | undefined;
    primers: number | null | undefined;
    primerSpeed: number | null | undefined;
    primerLength: number | null | undefined;
    materialUnloadingTime: number | null | undefined;
    quantity: number | null | undefined;
  }[];
} = {
  quantity: 3,
  materialGrade: MaterialGrade.STEEL,
  productsMarginRatio: 0,
  comment: "",
  declineReason: null,
  id: "quoteRequestLineId",
  index: 0,
  partId: "partId",
  quoteRequestId: "quoteRequestId",
  status: QuoteRequestLineStatusSchema.enum.DRAFT,
  createdAt: new Date("2024-01-01T00:00:00.000Z"),
  productLines: [
    {
      id: "productLineId",
      quantity: 1,
      price: 100,
      name: "product name",
      product: {
        price: 100,
        companyId: "companyId",
        id: "productId",
        name: "product name",
        supplierId: "supplierId",
      },
    },
  ],
  designOfficeHourlyRate: null,
  designOfficeTime: null,
  designOfficeMarginRatio: null,
  part: {
    id: "partId",
    materialGrade: MaterialGrade.ALUMINIUM,
    name: "part name",
    height: 2,
    length: 200,
    width: 200,
    quantityInAssembly: 1,
    type: "SHEET",
    files: [],
  },
  layout: {
    id: "layoutId",
    status: LayoutStatus.DRAFT,
    useNesting: null,
    materialSupplierId: "materialSupplierId",
    scrapRatio: 10,
    hasAutoScrapRatio: false,
    scrapMaterialBillingRate: 0,
    materialsLogisticsCostsRatio: 0,
    margin: 0,
    materialLayout: {
      price: 10,
      quantity: 1,
      maxPartsPerLayout: null,
      height: 1,
      length: 200,
      width: 200,
      type: PartTypeSchema.Enum.OTHER,
      materialGrade: MaterialGrade.STEEL,
    },
    quoteRequestLines: [],
  },
  processSteps: [
    {
      contourLengthMm: 200,
      linearSpeed: 2000,
      materialLoadTimeMinutes: 0,
      partLoadTimeMinutes: 0,
      machinePreparationTime: 0,
      machineHourlyPrice: 0,
      manTime: 0,
      manHourlyPrice: 0,
      fixedCost: 0,
      fixedCostPerSeries: 0,
      partsToControlRatio: 0,
      partsToPackQuantity: 0,
      packingHourlyPrice: 0,
      otherMachineTime: 0,
      bulkFactor: 0,
      primers: 0,
      primerSpeed: 0,
      primerLength: 0,
      materialUnloadingTime: 0,
      quantity: 0,
      isFixedCostPerSeries: false,
      margin: 0,
      actionsPerPartCount: 0,
      companyMachineId: "companyMachineId",
      id: "processId",
      industrialProcess: IndustrialProcess.LASER_CUT,
      machineActionsPerMinuteCount: 0,
      toolingCost: 0,
      productsMarginRatio: 0,
    },
  ],
};
